import React, { Component } from 'react';
import VIDEO_POSTER from '../assets/images/image-1.png';
import PLAY_BTN from '../assets/images/play-video.png';
import ICON_CHECK from '../assets/images/check.svg';
import VIDEO_PROMO from '../assets/media/gamification.mp4';
import { Modal } from 'react-bootstrap';

class Info extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false
    }
  }

  openModalHandler = () => {
    let show = this.state.isOpen;

    this.setState({ isOpen: !show });
  }

  _renderModal() {
    return (
      <Modal 
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={this.state.isOpen} 
        onHide={this.openModalHandler}
        dialogClassName="modal-player-video"
      >
        <Modal.Header closeButton />
        <Modal.Body>
          <div className="video-container">
            <video controls autoplay width="100%">
              <source src={VIDEO_PROMO} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  render() {
    return (
      <div className="info">
        <h4>¿Te gustaría implementar estas dinámicas en tu empresa? Contáctanos y prueba <strong>GameIf® GRATIS POR 30 DÍAS</strong></h4>
        <br />
        <h4>Mira el siguiente video para sabe más de GameIf</h4>
        <div className="video-box">
          <div className="overlay-image">
            <img src={VIDEO_POSTER} alt="" />
            <div className="overlay" onClick={this.openModalHandler}>
              <div>
                <img src={PLAY_BTN} alt="Reproducir video" />
              </div>
            </div>
          </div>
        </div>
        <div className="more-info">
          <p>Haz clic en el siguiente botón para que uno de nuestros ejecutivos se comunique contigo</p>
          <a href="https://gameif.media/" className="btn btn-gameif">
            Quiero saber más sobre Gameif
            <img src={ICON_CHECK} alt="" className="icon" />
          </a>
        </div>
        { this._renderModal() }
      </div>
    )
  }
}

export default Info;